import React, { useEffect, useState, useCallback } from "react";
import { Constant } from "../../../helper/constant";
import { useNavigate } from "react-router-dom";

import "./Dashboard.css";
import { formatToIDR } from "../../../helper/formatNumber";

const Dashboard = () => {
  // =====================
  // Constant Definition
  // =====================

  const navigate = useNavigate();
  const [topHighestProductSell, setTopHighestProductSell] = useState([]);
  const [topHighestMedicalTreatment, setTopHighestMedicalTreatment] = useState(
    []
  );
  const [isShowLoadingTopProduct, setIsShowLoadingTopProduct] = useState(false);
  const [
    isShowLoadingTopMedicalTreatment,
    setIsShowLoadingTopMedicalTreatment,
  ] = useState(false);

  // =====================
  // Network Definition
  // =====================

  const getTopHighestProductSell = useCallback(async () => {
    try {
      setIsShowLoadingTopProduct(true);
      const response = await fetch(
        Constant.BASE_API_URL + "/dashboard/top-produk",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (!response.ok) {
        alert("Gagal Mengambil Data");
        if (response.status === 401 || response.status === 403) {
          localStorage.clear();
          return navigate("/login", { replace: true });
        }
      }
      const json = await response.json();
      const data = json.data;
      const topProduct = data.top_products;
      if (!topProduct) {
        setTopHighestProductSell([]);
      } else {
        setTopHighestProductSell(topProduct);
      }
    } finally {
      setIsShowLoadingTopProduct(false);
    }
  }, [navigate]);

  const getTopHighestMedicalTreatment = useCallback(async () => {
    try {
      setIsShowLoadingTopMedicalTreatment(true);
      const response = await fetch(
        Constant.BASE_API_URL + "/dashboard/top-tindakan-medis",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (!response.ok) {
        alert("Gagal Mengambil Data");
        if (response.status === 401 || response.status === 403) {
          localStorage.clear();
          return navigate("/login", { replace: true });
        }
      }
      const json = await response.json();
      const data = json.data;
      const topTreatment = data.top_treatments;
      if (!topTreatment) {
        setTopHighestMedicalTreatment([]);
      } else {
        setTopHighestMedicalTreatment(topTreatment);
      }
    } finally {
      setIsShowLoadingTopMedicalTreatment(false);
    }
  }, [navigate]);

  useEffect(() => {
    getTopHighestProductSell();
    getTopHighestMedicalTreatment();
  }, [getTopHighestProductSell, getTopHighestMedicalTreatment]);

  return (
    <div>
      <h1>Dashboard</h1>
      <div className="dashboard-row-container">
        {/* Column 1 */}
        <div className="dashboard-column">
          <h3>Top Penjualan Produk</h3>
          {isShowLoadingTopProduct ? (
            <div className="loader-dashboard" />
          ) : (
            <table className="dashboard-table">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Nama Produk</th>
                  <th>Terjual</th>
                  <th>Total Transaksi</th>
                </tr>
              </thead>
              <tbody>
                {topHighestProductSell.map((product, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{product.product_name}</td>
                    <td>{product.quantity_sold}</td>
                    <td>{formatToIDR(product.total_transaction)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
        {/* Column 2 */}
        <div className="dashboard-column">
          <h3>Top Tindakan Medis</h3>
          {isShowLoadingTopMedicalTreatment ? (
            <div className="loader-dashboard" />
          ) : (
            <table className="dashboard-table">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Tindakan Medis</th>
                  <th>Jumlah</th>
                  <th>Total Transaksi</th>
                </tr>
              </thead>
              <tbody>
                {topHighestMedicalTreatment.map((treatment, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{treatment.medical_treatment_name}</td>
                    <td>{treatment.count}</td>
                    <td>{formatToIDR(treatment.total_transaction)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
